export default "__VITE_ASSET__BaNUVsVT__"